import { CliniciansSupportedFilters } from 'utils/filtersUtils';

export const PM_USERS_PAGE_SIZE = 50;
export const defaultPmUsersFilters: CliniciansSupportedFilters = {
  searchTerm: '',
  credentialIds: [],
  userStatuses: [],
  roleIds: []
};
